var ICON_URL = process.env.REACT_APP_ICONS_API;
export var getRemoteIconURL = function (type, icon) {
    return "".concat(ICON_URL, "/").concat(type, "/").concat(icon);
};
export var getAssetIcon = function (assetName) {
    return getRemoteIconURL('asset', assetName);
};
